import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 5659F8EC-377D-41D2-AB3A-52DC40815DC7
 * name square
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/square.svg
 * tags
 * - Shape 
 */
export const SquareIcon = createSvgIcon(<><path d="M3,3V21H21V3" /></>, 'SquareIcon');
export default SquareIcon